export enum Lang {
  En = 'en',
  Es = 'es',
}
